/** Keep browser analytics navigation metadata free of URL query and fragment data. */
export function pathnameOnly(path: string): string {
  const queryIndex = path.indexOf('?')
  const fragmentIndex = path.indexOf('#')
  const end = [queryIndex, fragmentIndex]
    .filter((index) => index >= 0)
    .reduce((earliest, index) => Math.min(earliest, index), path.length)
  return path.slice(0, end) || '/'
}
